module.exports = __webpack_public_path__ + "static/media/advanced_detail.9b47ade8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/WebApp/assets/advanced_detail.png
// module id = 556
// module chunks = 0